export const generatePassword = (length = 12) => {
  const upperCase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowerCase = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const specialChars = "!@#$%^&*()-_+=<>?";
  const allChars = upperCase + lowerCase + numbers + specialChars;

  let newPassword = [
    upperCase[Math.floor(Math.random() * upperCase.length)],
    lowerCase[Math.floor(Math.random() * lowerCase.length)],
    numbers[Math.floor(Math.random() * numbers.length)],
    specialChars[Math.floor(Math.random() * specialChars.length)],
  ];

  for (let i = newPassword.length; i < length; i++) {
    newPassword.push(allChars[Math.floor(Math.random() * allChars.length)]);
  }

  newPassword = newPassword.sort(() => Math.random() - 0.5);

  return newPassword.join("");
};

const getRandomChar = (pool) => pool[Math.floor(Math.random() * pool.length)];

export const generatePasswordAlphanumeric = () => {
  const chars = [...Array(3)]
    .map(() => getRandomChar("0123456789"))
    .concat(
      [...Array(3)].map(() =>
        getRandomChar("ABCDEFGHIJKLMNOPQRSTUVWXYZ")
      )
    )
    .sort(() => Math.random() - 0.5).join("");
  return "ILHIGA-" + chars;
};
